import { keysToCamelCase } from "zod-to-camel-case";

import { assetFixture } from "@/schema/public/asset/asset.fixture";
import type {
    PublishedAssets,
    PublishedAssetsCamel,
} from "@/schema/published/publishedAssets/publishedAssets.schema";

export const publishedAssetsFixture = ({
    overrides = {},
}: {
    overrides?: Partial<PublishedAssets>;
} = {}): PublishedAssets => {
    const { asset_id, asset_type, asset_uid, created_at, updated_at, asset_object } =
        assetFixture();
    return { asset_id, asset_type, asset_uid, created_at, updated_at, asset_object, ...overrides };
};

export const publishedAssetsFixtureCamel = ({
    overrides = {},
}: {
    overrides?: Partial<PublishedAssetsCamel>;
} = {}): PublishedAssetsCamel => ({
    ...keysToCamelCase(publishedAssetsFixture()),
    ...overrides,
});
